import { render } from "./Products.vue?vue&type=template&id=31305b2b&scoped=true&bindings={}"
import script from "./Products.vue?vue&type=script&lang=ts"
export * from "./Products.vue?vue&type=script&lang=ts"

import "./Products.vue?vue&type=style&index=0&id=31305b2b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-31305b2b"

export default script